
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Users from "./pages/Users";
import MatchRequests from "./pages/MatchRequests";
import { useContext, useEffect, useState, createContext } from "react";
import { AuthContext } from "./contexts/AuthContext";
import { Navigate } from "react-router-dom";
import Login from "./pages/Login";
import ChatWrapper from "./pages/ChatWrapper";
import Meetings from "./pages/Meetings";
import EmailVerification from "./pages/EmailVerification";
import ProfileInfo from "./pages/ProfileInfo";
import Impressum from "./pages/Impressum";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import GDPR from "./pages/GDPR";
import ConsentDialog from "./components/ConsentDialog";
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { inject } from '@vercel/analytics';
import UserPreview from "./pages/UserPreview";
import Support from "./pages/Support";
import axiosInstance from './utils/axiosInstance';
import GlobalLoader from "./components/GlobalLoader";

inject();

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);

const Protected = ({ children }) => {
  const { token } = useContext(AuthContext);
  return token ? children : <Navigate to="/login" />;
};

function AppContent() {
  const { loading, setLoading } = useLoading();
  const location = useLocation();

  useEffect(() => {
    const fetchCSRFToken = async () => {
      try {
        await axiosInstance.get('/api/csrf-token');
        console.log('✅ CSRF token fetched');
      } catch (err) {
        console.error('❌ Failed to fetch CSRF token:', err.message);
      }
    };

    fetchCSRFToken();
  }, []);

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return (
    <HelmetProvider>
      <Helmet>
        <title>PairLingo - Language Learning Community</title>
        <meta name="description" content="PairLingo helps you find language partners to practice and improve your language skills." />
        <meta name="keywords" content="language exchange, language learning, language partners, chat, meet, practice languages" />
        <meta name="author" content="PairLingo Team" />
      </Helmet>
      {loading && <GlobalLoader />}
      <Navbar />
      <div className="p-4">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/user-preview" element={<UserPreview />} />
          <Route path="/register" element={<Register />} />
          <Route path="/support" element={<Protected><Support /></Protected>} />
          <Route path="/users" element={<Protected><Users /></Protected>} />
          <Route path="/profile" element={<Protected><Profile /></Protected>} />
          <Route path="/meetings" element={<Meetings />} />
          <Route path="/requests" element={<Protected><MatchRequests /></Protected>} />
          <Route path="/login" element={<Login />} />
          <Route path="/chat/:matchId" element={<Protected><ChatWrapper /></Protected>} />
          <Route path="/verify" element={<EmailVerification />} />
          <Route path="/profile-info" element={<ProfileInfo />} />
          {/* <Route path="/impressum" element={<Impressum />} /> */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/gdpr" element={<GDPR />} />
        </Routes>
      </div>
      <Footer />
      <ConsentDialog />
    </HelmetProvider>
  );
}

function App() {
  return (
    <LoadingProvider>
      <Router>
        <AppContent />
      </Router>
    </LoadingProvider>
  );
}

export default App;
